import { Spinner } from '.'

export const LoadingScreen = () => {
  return (
    <div className="z-10 h-screen bg-gray-500 bg-opacity-50 w-screen fixed inset-0 flex justify-center items-center">
      <Spinner className="w-16 h-16 text-white fill-blue-500" />
    </div>
  )
}
